import IconGift from "@src/assets/icons/lucide/gift.svg?react";
import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import clsx from "clsx";
import { getReferralProgress } from "./lib/get-referral-progress";
import { useMyReferralProfile } from "./queries/get-my-referral-profile";
import { openReferralModal } from "./referral-modal";

export function ReferralNavIcon() {
	const { data: referralProfile } = useMyReferralProfile();
	const validReferrals =
		referralProfile?.qualifiedReferralCount ??
		referralProfile?.referrals?.length ??
		0;
	const { isInPhase1 } = getReferralProgress(validReferrals);
	const isNewcomer = validReferrals === 0;
	const hasUnclaimedBonus = isInPhase1 && isNewcomer;

	return (
		<Tooltip label="Invite friends, get 1 month free" position="top">
			<button
				type="button"
				onClick={openReferralModal}
				aria-label="Referral program"
				className={clsx(
					"relative flex shrink-0 items-center justify-center",
					"size-8 rounded-lg leading-none cursor-pointer",
					"text-text-secondary hover:text-text-primary",
					"hover:bg-surface-hover-subtle transition-colors",
				)}
			>
				<IconGift className="size-4 shrink-0" aria-hidden />
				{hasUnclaimedBonus && (
					<span
						className={clsx(
							"absolute top-1 right-1 size-2 rounded-full",
							"bg-amber-500 ring-2 ring-surface-default",
						)}
						aria-hidden
					/>
				)}
			</button>
		</Tooltip>
	);
}
